module.exports = __webpack_public_path__ + "static/media/registration.4b91ebe6.png";